module.exports = __webpack_public_path__ + "img/dash-mega.81d2db65.svg";